<template>
    <v-row>
        <v-col cols="12" sm="6" md="6">
            <v-card-text class="mx-auto m-txt-center">
                <div><a @click="recoverPwd()">{{getMultiOpt === 2 ? getTextRecover : getTextLogin}}</a></div>
            </v-card-text>
        </v-col>

        <v-col cols="12" sm="6" md="6">
            <v-card-text class="mx-auto m-txt-center">
                <div><a href="#">Registar-se para obter uma conta</a></div>
            </v-card-text>
        </v-col>
    </v-row>
</template>

<script>
    import {mapHelper} from "../../store/helper";

    export default {
        name: "OptionForm",
        methods:{
            recoverPwd(){
                if(this.$store.getters.getMultiOpt === 2) return  this.$store.dispatch('startMultiOpt', 1);
                this.$store.dispatch('startMultiOpt', 2);
                return false;
            }
        },
        computed:{
            ...mapHelper
        }
    }
</script>

<style scoped>

</style>